/* eslint-disable react-hooks/exhaustive-deps */
import SearchIcon from "@mui/icons-material/Search";
import StyleIcon from "@mui/icons-material/Style";
import { Grid, Tooltip, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { ListTablePaginated } from "../../../../general_components/ListTablePaginated";
import { SimpleDialogComponent } from "../../../../general_components/SimpleDialogComponent";
import { SnackbarMessenger } from "../../../../general_components/SnackbarMessenger";
import { getContenidosSearchPaginated } from "../../helpers/ContenidosData";
import { imprimirEtiquetas } from "../../helpers/EtiquetasData";
import { TheLayoutContext } from "src/context/TheLayoutContext";
import { Typography } from '@mui/material';
import { Buttons } from "src/general_components/Buttons";
import { setComprobantesDigitalizacionesData } from "../../helpers/ComprobantesDigitalizacionesData"
import { getTiposContenidos } from "../../helpers/TipoContenidosData";
import { SearchFormGeneral } from "../SearchFormGeneral";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DigitalizacionesContenido } from "./DigitalizacionesContenido";
import Link from '@mui/material/Link';
import InfoIcon from '@mui/icons-material/Info';
import Popover from '@mui/material/Popover';
import HistoryIcon from "@mui/icons-material/History";
import { getContenidosSearchHistorico } from "../../helpers/HistoricoCajasData";
import { MovimientosTimelineMUI } from "../MovimientosTimelineMUI";
import esArray from "src/general_components/functionEsArray";
import { estadoColores, estadoIconos } from "../estadosCajas";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import AddIcon from "@mui/icons-material/Add";
import { FormCajasProcesosVarios } from "../FormCajasProcesosVarios";
// import { getTipoContenidosLocalizaciones } from "src/projects/gestion_comercial/cuentas/helpers/TipoContenidosData";
import EditIcon from '@mui/icons-material/Edit';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { postCajas } from "../../helpers/CajasData";
import { ConfimDialogComponent } from "src/general_components/ConfirmDialogComponent";
import { obtenerProcesosPorPerfilYMenu } from "src/general_components/functionEsArray";

export const DigitalizacionesList = () => {
  const { dataSearchFormGeneral, setSelectionModel, snackbarVisible, setSnackbarVisible, message, setMessage, severity, setSeverity,
    setRequiredFormCuentaSector, setRequiredTipoContenido, setShowFormUbicaciones, setShowFormIdCajas,
    setShowFormEstadosCajas, setShowFormFechaAltaCajas, setRequiredSector, setSelected, setListRecords,
    setRows, contenidoSeleccionado, setOmitirQuerySearch, clienteName, metadatosContenidoSeleccionado,
    setDigitalizacionesSeleccionadas, setDigitalizacionesSeleccionadasCompleto, setShowFormMetadatos,
    digitalizacionesAfacturar, setDigitalizacionesAfacturar, abrirAgregarContenido, openDialogImage, setOpenDialogImage, clienteIdSearch,
    setSoloCajas, actualizarListado, setActualizarListado, setShowFormMovimientos, tipoContenidosCuentaLocalizaciones, setIdsCajasCreadas,
    setDisabledButtonsCopy, idsCajasCreadas, setDataSearchFormGeneral, setBusquedaSearchOn, setDigitalizacionesCoincidencias, setActualizarListadoContenidos,
    setListDatosFormIdCajas, setListDatosEstadosCajas, setDataSearchFormEstadosCajas,
    setListDatosFechaAltaCajas, setListDatosFormCuentaSector, setClienteIdSearch,
  } = useContext(CajasContext);
  const [open, setOpen] = useState(null);
  const [pushData, setPushData] = useState(false);
  const [abrirBusqueda, setAbrirBusqueda] = useState(false);
  const { setChildFooterLeft, setChildFooter, setExpand } = useContext(TheLayoutContext);
  let cajaSelect = "";
  // const [tipoContenidoSelect, setTipoContenidoSelect] = useState(tipoContenidoSeleccionado);
  const [eliminar, setEliminar] = useState(false);
  const [dataBusqueda, setDataBusqueda] = useState(false);
  const [tipoContenidoList, setTipoContenidoList] = useState([]);
  const [abrirRespuestaComprobante, setAbrirRespuestaComprobante] = useState(false);
  const [respuestaComprobante, setRespuestaComprobante] = useState("");
  let proceso = "Digitalizacion";
  const strDigitalizacionesSeleccionadasCompleto = digitalizacionesAfacturar.digitalizaciones_contenidos.length > 0 ?
    JSON.stringify(digitalizacionesAfacturar.digitalizaciones_contenidos) : "";
  const [alertImagesSave, setAlertImagesSave] = useState("");
  const [dataPostContenido, setDataPostContenido] = useState({});
  const [cuentaDigitalizaciones, setCuentaDigitalizaciones] = useState(false);
  const [modalStateHistorico, setMOdalStateHistorico] = useState(false);
  const [historicoCaja, setHistoricoCaja] = useState(false);
  const [params, setParams] = useState(false);
  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_perfil_usuario = user_data?.id_perfiles;
  const [conJerarquia, setConJerarquia] = useState(false);
  const [modalStateCajasForm, setModalStateCajasForm] = useState(false);
  const [nameFormCajas, setNameFormCajas] = useState("");
  const [clienteSectorFormCajas, setClienteSectorFormCajas] = useState(false);
  const [sectorIdFormCajas, setSectorIdFormCajas] = useState("");
  const [descripcionCuentaSectorFormCajas, setDescripcionCuentaSectorFormCajas] = useState("");
  const [dataCajasFormEdit, setDataCajasFormEdit] = useState(false);
  const [idCaja, setIdCaja] = useState(false);
  const [mensajeExcedida, setMensajeExcedida] = useState("");
  const [cajaExcedida, setCajaExcedida] = useState(false);
  const [modalStateExcedida, setModalStateExcedida] = useState(false);
  const [cajaDeformada, setCajaDeformada] = useState(false);
  const [modalStateDeformada, setModalStateDeformada] = useState(false);
  const [mensajeDeformada, setMensajeDeformada] = useState("");
  const [responseService, setResponseService] = useState(false);
  const restricciones = obtenerProcesosPorPerfilYMenu();

  let Imprimir = true;
  let Historico = true;
  let Editar = true;
  let MarcarExcedida = true;
  let MarcarDeformada = true;
  let AgregarCajas = true;
  let AgregarCajasGeneral = true;
  let abmContenidos = true;
  if (restricciones) {
    Imprimir = restricciones.Imprimir;
    Historico = restricciones.Historico;
    Editar = restricciones.Editar;
    MarcarExcedida = restricciones.MarcarExcedida;
    MarcarDeformada = restricciones.MarcarDeformada;
    AgregarCajasGeneral = restricciones.AgregarCajasGeneral;
    abmContenidos = restricciones.abmContenidos
  }


  //NOTE SIRVE PARA PODER GUARDAR EL ID DE TIPO DE CONTENIDO Y PASARSELO AL FORMULARIO DE AGREGAR CONTENIDO
  // useEffect(() => {
  //   setTipoContenidoSelect(tipoContenidoSeleccionado);
  // }, [tipoContenidoSeleccionado]);

  var columns = [];
  let details = navigator.userAgent;
  let regexp = /android|iphone|kindle|ipad/i;

  let isMobileDevice = regexp.test(details);
  if (isMobileDevice) {
    columns = [
      {
        field: "clienteName",
        headerName: "Cliente",
        headerAlign: "center",
        flex: 150,
        minWidth: 150,
        maxWidth: 175
      },
      {
        field: "sectorName",
        headerName: "Sector",
        headerAlign: "center",
        flex: 150,
        minWidth: 150,
        maxWidth: 175
      },
      {
        field: "concatCaja",
        headerName: "Caja",
        headerAlign: "left",
        flex: 0.6,
        renderCell: (params) => {
        
          if (params.value) {
            return (
              <Grid container alignItems="center">
                {params.row.excedida === "1" && (
                  <Tooltip title="Excedida">
                    <span>
                      <WarningAmberIcon size="small" style={{ color: "red", fontSize: 20 }} />
                    </span>
                  </Tooltip>
                )}
                {params.row.deformada === "1" && (
                  <Tooltip title="Deformada">
                    <span>
                      <BrokenImageIcon size="small" style={{ color: "red", fontSize: 20 }} />
                    </span>
                  </Tooltip>
                )}
             
                <Typography variant="body1" style={{ fontSize: 13, fontFamily: 'Roboto, sans-serif', marginLeft: 5, color: 'black' }}>
                  {params.value}
                </Typography>
              </Grid>
            );
          } else {
            return null;
          }
        },
      },
      {
        field: "estados_cajas",
        headerName: "Estado",
        headerAlign: "center",
        flex: 1,
      },
      {
        //Boton Imprimir
        field: "actions",
        headerName: "Acciones",
        type: "actions",
        flex: 2,
        // width: 100,
        // minWidth: 100,
        // maxWidth: 125,
        getActions: (params) => [
          <GridActionsCellItem
            icon={
              <Tooltip title="Acciones">
                <span>
                  <MoreVertIcon color="info" />
                </span>
              </Tooltip>
            }
            onClick={(e) => {
              handleOpenMenu(e);
              setParams(params)
            }}
            label="Acciones"
            {...(params.id.includes("cliente") || params.id.includes("sector")
              ? { hidden: true }
              : {})}
          />,
          <GridActionsCellItem
            {...(params.id.includes("cliente") || params.id.includes("sector")
              ? { hidden: true }
              : {})}
            icon={
              <Tooltip title="Historico">
                <span>
                  <HistoryIcon color="info" />
                </span>
              </Tooltip>
            }
            onClick={() => {
              toggleModalHistorico(params.id);
            }}
            label="Cajas"
          />
        ],
      },
    ];
  } else {
    columns = [
      {
        field: "clienteName",
        headerName: "Cliente",
        headerAlign: "left",
        flex: 1,
      },
      {
        field: "sectorName",
        headerName: "Sector",
        headerAlign: "left",
        flex: 1,
      },
      {
        field: "concatCaja",
        headerName: "Caja",
        headerAlign: "left",
        flex: 0.6,
        renderCell: (params) => {

          if (params.value) {
            return (
              <Grid container alignItems="center">
                {params.row.excedida === "1" && (
                  <Tooltip title="Excedida">
                    <span>
                      <WarningAmberIcon size="small" style={{ color: "red", fontSize: 20 }} />
                    </span>
                  </Tooltip>
                )}
                {params.row.deformada === "1" && (
                  <Tooltip title="Deformada">
                    <span>
                      <BrokenImageIcon size="small" style={{ color: "red", fontSize: 20 }} />
                    </span>
                  </Tooltip>
                )}
                
                <Typography variant="body1" style={{ fontSize: 13, fontFamily: 'Roboto, sans-serif', marginLeft: 5, color: 'black' }}>
                  {params.value}
                </Typography>
              </Grid>
            );
          } else {
            return null;
          }
        },
      },
      // Las siguientes columnas se ocultarán si id_perfil_usuario es igual a 6
      ...(id_perfil_usuario !== "9" ? [
        {
          field: "ubicacion",
          headerName: "Ubicacion",
          headerAlign: "left",
          flex: 0.6,

        },
        {
          field: "tipo_cajas",
          headerName: "Tipo de Caja",
          headerAlign: "left",
          flex: 0.5,
        },
        {
          field: "estados_cajas",
          headerName: "Estado",
          headerAlign: "left",
          flex: 0.5,
          renderCell: (params) => {
            if (params.value) {
              const color = estadoColores[params.value] || "defaultColor"; // Color predeterminado si el estado no tiene un color definido
              const icono = estadoIconos[params.value] || <ErrorOutlineIcon />; // Icono predeterminado si el estado no tiene un icono definido
              return (
                <Grid>
                  <Button
                    size="small"  // Tamaño más pequeño
                    variant="text"
                    style={{

                      color: color,

                    }}
                    disabled  // Desactiva la interacción del botón
                    startIcon={icono}  // Icono en el inicio del botón
                  >
                    {params.value}
                  </Button>
                </Grid>
              );
            } else {
              return null;
            }
          },
        },
        {
          //Boton Imprimir
          field: "actions",
          headerName: "Acciones",
          type: "actions",
          flex: 1,
          getActions: (params) => [
            <GridActionsCellItem
              icon={
                <Tooltip title="Acciones">
                  <span>
                    <MoreVertIcon color="info" />
                  </span>
                </Tooltip>
              }
              onClick={(e) => {
                handleOpenMenu(e);
                setParams(params)
              }}
              label="Acciones"
              {...(params.id.includes("cliente") || params.id.includes("sector")
                ? { hidden: true }
                : {})}
            />,
            <GridActionsCellItem
              {...(params.id.includes("cliente") || params.id.includes("sector")
                ? { hidden: true }
                : {})}
              icon={
                <Tooltip title="Historico">
                  <span>
                    <HistoryIcon color="info" />
                  </span>
                </Tooltip>
              }
              hidden={Imprimir || Historico || Editar || MarcarExcedida || MarcarDeformada || AgregarCajas ? false : true}
              onClick={() => {
                toggleModalHistorico(params.id);
              }}
              label="Cajas"
            />
          ],
        }] : []),
    ];
  }

  const toggleModalHistorico = async (id) => {
    const response = await getContenidosSearchHistorico(id, "caja")
    if (response) {
      setHistoricoCaja(esArray(response.wsResponse.movimientos?.historico));
      toggleModalMovimientos();
    } else {
    }
  };


  const toggleModalMovimientos = async () => {
    setMOdalStateHistorico(!modalStateHistorico);
  };


  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };


  //Funcion para el boton imprimir
  const onClickEtiqueta = () => {
    //slice elimina los primer 4 carácter de un string(CAJA)
    const newId = params.id;
    const URI_aux = imprimirEtiquetas(newId);
    if (URI_aux) window.open(URI_aux, "_blank");
  };


  const buttonBuscar = () => (
    <Button
      endIcon={<SearchIcon />}
      onClick={() => {
        setOmitirQuerySearch(true);
        setDataInfoBusqueda({});
        setRequiredFormCuentaSector(true);
        setRequiredTipoContenido(true);
        setAbrirBusqueda(!abrirBusqueda);
        if (id_perfil_usuario === '9') {
          setRequiredFormCuentaSector(true);
          setShowFormUbicaciones(false);
          setShowFormEstadosCajas(false);
          setShowFormFechaAltaCajas(false);
          setShowFormMovimientos(false);
        }
        setShowFormMetadatos(true);
        setShowFormIdCajas(true);
        setRequiredSector(true);
        setSoloCajas(true);
      }}
      variant="contained"
      style={{
        color: '#FFFFFF',
        fontFamily: 'Roboto, sans-serif',
        minWidth: '120px',
        width: '120px',
        fontSize: '11px',
        height: '30px',
      }}
    >
      Buscar
    </Button>
  );

  const buttonAgregarCajas = (params) => (
    <Tooltip title="Agregar Cajas">
      <Button
        startIcon={<AddIcon />}
        onClick={() => {
          setNameFormCajas("Alta de Cajas")
          setClienteSectorFormCajas(true);
          toggleModalCajasForm(params.id);
        }}
        color="success"
        variant="contained"
        style={{
          color: '#FFFFFF',
          fontFamily: 'Roboto, sans-serif',
          minWidth: '120px',
          width: '120px',
          fontSize: '11px',
          height: '30px',
        }}
      >
        Cajas
      </Button>
    </Tooltip>

  );

  //Funcion que abre y cierra el modal del formulario de cajas
  const toggleModalCajasForm = async (data, id) => {
    setIdsCajasCreadas('')
    setDisabledButtonsCopy(false)
    if (!modalStateCajasForm) {
      setActualizarListado(false);
    } else {
      // setActualizarListado(true);
      const cajas = data?.wsResponse?.cajas || idsCajasCreadas ? idsCajasCreadas : []
      let registrosFormateados = esArray(cajas).map((data) => {
        return { id: data };
      });
      if (registrosFormateados.length > 0) {
        recargarPaginaProcesados(registrosFormateados, id);
      }
      setClienteSectorFormCajas(false);
      setSectorIdFormCajas("");
      setDataCajasFormEdit(false);
      setDescripcionCuentaSectorFormCajas("")
      setNameFormCajas("");

    }
    setModalStateCajasForm(!modalStateCajasForm);

  };

  //Funcion encargada de recargar la pagina con los ids procesados
  const recargarPaginaProcesados = (registrosFiltrados, id) => {
    if (!id || id === "") {
      const arrayIndexado = registrosFiltrados.map(item => item.id);
      const cadenaFormateada = arrayIndexado.join(',');
      const data = {
        coincidencias: '1',
        eliminados: '0',
        search_params: {
          cajas: {
            fisica: '1',
            ...(cadenaFormateada !== "" && { idCajasRango: cadenaFormateada }),
            ...(cadenaFormateada !== "" && { id_cajas: cadenaFormateada })
          }
        },
        soloCajas: '1'
      };
      setDataSearchFormGeneral(data);
    }
    setBusquedaSearchOn(true);
    setActualizarListado(true)
  }

  const [options, setOptions] = useState({
    cols: columns,
    getPaginated: getContenidosSearchPaginated,
    setListRecords: setListRecords,
    pageSize: [5, 10, 25],
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    notas: true,
    sinFilas: true,
    idElementData: dataSearchFormGeneral,
    hierarchyOn: true,
    detailsOn: true,
    abmContenidos: abmContenidos? true : "false",
    checkboxContenidos: "false",
    digitalizacionesOn: true,
    soloContenidosSearch: true,
    totales: true,
    buttonExtraOn: true,
    ButtonExtra: buttonBuscar,
    buttonExtraViewOn: AgregarCajasGeneral ? true : false,
    ButtonExtraView: buttonAgregarCajas,
    setResponseService:setResponseService
  });

  const [options2, setOptions2] = useState({
    cols: columns,
    getPaginated: getContenidosSearchPaginated,
    setListRecords: setListRecords,
    pageSize: [5, 10, 25],
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    notas: true,
    sinFilas: true,
    idElementData: dataSearchFormGeneral,
    hierarchyOn: false,
    detailsOn: true,
    abmContenidos: abmContenidos? true : "false",
    checkboxContenidos: "false",
    digitalizacionesOn: true,
    soloContenidosSearch: true,
    totales: true,
    buttonExtraOn: true,
    ButtonExtra: buttonBuscar,
    buttonExtraViewOn: AgregarCajasGeneral ? true : false,
    ButtonExtraView: buttonAgregarCajas,
    setResponseService:setResponseService
  });
  
  const obtenerTipoContenido = async () => {
    let tipoContenidos = [];
    let responseStorage = JSON.parse(localStorage.getItem("siam-tipo_contenidos"));
    if (responseStorage === null) {
      tipoContenidos = await getTiposContenidos(true);
    } else {
      let tipoContenidosStorage = esArray(responseStorage.tipo_contenidos);
      if (responseStorage !== null) {
        tipoContenidos = tipoContenidosStorage;
      }
    }
    // TODO: Se hace el filtro por tipo contenidos cuentas localizaciones
    // Tipo Contenidos cuentas localizaciones
    // let data = await getTipoContenidosLocalizaciones();
    let data = tipoContenidosCuentaLocalizaciones;
    const id_sector = contenidoSeleccionado.id_cuentas_localizaciones;
    const cuentas_localizaciones_tipo_contenidos = esArray(data).filter(objeto => objeto.id_cuentas_localizaciones === id_sector);
    const tipoContenidosFiltradoCuentaLocalizacion = tipoContenidos.filter((tipoContenido) =>
      cuentas_localizaciones_tipo_contenidos?.some((obj) => obj.id_tipo_contenidos === tipoContenido.id));

    tipoContenidos = tipoContenidosFiltradoCuentaLocalizacion.filter(objeto => objeto.digitalizado === "1");
    if (tipoContenidoList.length === 0) {
      const listRowsTipoContenidos = tipoContenidos.map((tipo_contenido) => {
        tipo_contenido.value = tipo_contenido.id;
        tipo_contenido.label = tipo_contenido.detalle;
        return tipo_contenido;
      });
      setTipoContenidoList(listRowsTipoContenidos);
    }
  };


  // ── Bridge con el Asistente IA ──────────────────────────────────────────────
  useEffect(() => {
    const handleAIAction = (e) => {
      const { type, params: p } = e.detail || {};

      if (type === "search_digitalizaciones") {
        const searchParams = {};
        const cajasParams = { fisica: "1" };
        if (p?.id_cajas)   { cajasParams.id_cajas = String(p.id_cajas); cajasParams.idCajasRango = String(p.id_cajas); }
        if (p?.referencia) cajasParams.referencia = String(p.referencia);
        searchParams.cajas = cajasParams;

        setListDatosFormIdCajas({
          id_cajas:            p?.id_cajas   ? String(p.id_cajas)   : "",
          idCajasRango:        p?.id_cajas   ? String(p.id_cajas)   : "",
          referencia:          p?.referencia ? String(p.referencia) : "",
          id_cajas_desde:      "",
          id_cajas_hasta:      "",
          tiposCajasSeleccionadas: [],
          referenciasRango:    "",
          ordenamiento:        "",
          excedida:            "2",
          deformada:           "2",
        });

        if (p?.estados?.length) {
          const estadosArr = p.estados.map((e) => ({ id: String(e.id), detalle: e.detalle }));
          setListDatosEstadosCajas(estadosArr);
          const estadosPayload = {};
          estadosArr.forEach((e) => { estadosPayload[e.id] = e.detalle; });
          setDataSearchFormEstadosCajas(estadosPayload);
          searchParams.estados_cajas = estadosPayload;
        } else {
          setListDatosEstadosCajas([]);
          setDataSearchFormEstadosCajas([]);
        }

        if (p?.fecha_desde || p?.fecha_hasta) {
          const fechas = { fecha_desde: p.fecha_desde || "", fecha_hasta: p.fecha_hasta || "" };
          setListDatosFechaAltaCajas(fechas);
          searchParams.fecha_creacion_cajas = fechas;
        } else {
          setListDatosFechaAltaCajas([]);
        }

        if (p?.id_cuenta) {
          searchParams.cuentas_localizaciones = { id_cuentas: String(p.id_cuenta) };
          setListDatosFormCuentaSector({ cuenta: String(p.id_cuenta) });
          setClienteIdSearch({ id_cuentas: String(p.id_cuenta), razon_social: p.razon_social || "" });
        } else {
          setListDatosFormCuentaSector({});
        }

        setDataSearchFormGeneral({
          coincidencias: "1",
          eliminados: "0",
          search_params: searchParams,
        });
        setBusquedaSearchOn(true);
        setActualizarListado(true);
      }

      if (type === "open_search") {
        setAbrirBusqueda(true);
      }
    };

    window.addEventListener("ai:action", handleAIAction);
    return () => window.removeEventListener("ai:action", handleAIAction);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ───────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    obtenerTipoContenido();
    setRows([]);
  }, [openDialogImage]);

  useEffect(() => {
    if(responseService && responseService.status && responseService.digitalizaciones_coincidencias 
      && responseService.digitalizaciones_coincidencias !== ""){
        setDigitalizacionesCoincidencias(responseService.digitalizaciones_coincidencias);
      };
  }, [responseService]);


  useEffect(() => {
    if (!Array.isArray(dataSearchFormGeneral) && actualizarListado) {
      setConJerarquia(dataSearchFormGeneral.jerarquia);
      //NOTE MODIFICO EL OPTION DEL LISTADO PARA QUE MUESTRE LOS DATOS
      setOptions({
        ...options,
        idElementData: dataSearchFormGeneral,
        sinFilas: false,
      });
      setOptions2({
        ...options,
        idElementData: dataSearchFormGeneral,
        sinFilas: false,
      });
      setActualizarListado(false);
    } else if (Object.entries(dataPostContenido).length > 0) {
      setOptions({
        ...options,
        idElementData: dataSearchFormGeneral,
        sinFilas: false,
      });
      setOptions2({
        ...options,
        idElementData: dataSearchFormGeneral,
        sinFilas: false,
      });
      setDataPostContenido({});
    } else if (cajaSelect) {
      setOptions({
        ...options,
        sinFilas: true,
      });
      setOptions2({
        ...options,
        sinFilas: true,
      });
    }

    if (abrirAgregarContenido === false && eliminar === false) {
      //SIRVE PARA RESTABLECER LOS VALORES DE LOS SELECTORES COMO VACIO
      // setContenidoSeleccionado([]);
      setSelected([]);
    }

    if (alertImagesSave === true) {
      setActualizarListado(true);
      setSnackbarVisible(true);
      setSeverity("success");
      setMessage(
        "Se almacenaron todas las digitalizaciones/actualizaciones correctamente"
      );
      setAlertImagesSave("");
      // setActualizarListadoContenidos(true);
    } else if (alertImagesSave === false) {
      setAlertImagesSave("");
      setSnackbarVisible(true);
      setSeverity("warning");
      setMessage(
        "Hubo un error al almacenar las digitalizaciones/actualizaciones"
      );
    }
  }, [
    actualizarListado,
    dataBusqueda,
    abrirAgregarContenido,
    cajaSelect,
    alertImagesSave,
    dataPostContenido,
    dataSearchFormGeneral,
  ]);


  //DATOS DEL JSONFORM DE BUSQUEDA
  const [dataInfoBusqueda, setDataInfoBusqueda] = useState({
    grupo: "",
    contrato: "",
    titular: "",
  });


  if (pushData) {
    if (abrirBusqueda) {
      //CIERRO EL DIALOGO DE BUSQUEDA
      setAbrirBusqueda(!abrirBusqueda);
      //SETEO LOS DATOS PARA QUE EL OTRO COMPONENTE PUEDA LEERLOS
      setDataBusqueda(dataInfoBusqueda);
      //SETEO EL ESTADO PARA QUE SE ACTUALICE EL LISTADO
      setActualizarListado(true);
    }
    setPushData(!pushData);
  }


  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'F2') {
        setOmitirQuerySearch(true);
        setDataInfoBusqueda({});
        setRequiredFormCuentaSector(true);
        setRequiredTipoContenido(true);
        setAbrirBusqueda(!abrirBusqueda);
        setShowFormUbicaciones(false);
        setShowFormEstadosCajas(false);
        setShowFormFechaAltaCajas(false);
        setRequiredSector(true);
        setSoloCajas(true);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);


  const toggleModal = () => {
    setAbrirBusqueda(!abrirBusqueda);
    setDataBusqueda(dataInfoBusqueda);
    //SETEO EL ESTADO PARA QUE SE ACTUALICE EL LISTADO
    setActualizarListado(true);
  };


  const toggleModalRespuestaComprobante = () => {
    setAbrirRespuestaComprobante(!abrirRespuestaComprobante);
    setRespuestaComprobante("");
    setDigitalizacionesAfacturar({ digitalizaciones_contenidos: [], contenidos: [] })
  };


  const limpiarFooter = (prop) => {
    setDigitalizacionesSeleccionadasCompleto({ digitalizaciones_contenidos: [], contenidos: [] });
    setExpand(false);
    setChildFooter(null);
    setChildFooterLeft(null);
    setSelectionModel([])
    setDigitalizacionesAfacturar({ digitalizaciones_contenidos: [], contenidos: [] })
  };


  useEffect(() => {
    if (digitalizacionesAfacturar.digitalizaciones_contenidos.length > 0) {
      setChildFooterLeft(
        <Grid container >
          <Grid item xs={10} textAlign='left' marginLeft={"30%"}>
            <Typography sx={{ fontSize: 14 }}>Cliente : {clienteName}</Typography>
            <Typography sx={{ fontSize: 14 }}>Digitalizaciones: {strDigitalizacionesSeleccionadasCompleto} </Typography>
            <Typography sx={{ fontSize: 14 }}>Total Contenidos: {digitalizacionesAfacturar.contenidos.length}</Typography>
            <Typography sx={{ fontSize: 14 }}>Total Digitalizaciones: {digitalizacionesAfacturar.digitalizaciones_contenidos.length}</Typography>

          </Grid>
        </Grid>
      );
      setChildFooter(
        <Grid marginRight={'20%'}>
          <Buttons
            labelButtonSave={"Generar"}
            labelButtonClose={"Cancelar"}
            buttonCerrar={limpiarFooter}
            onClickSubmit={onClickSubmit}
          />
        </Grid>
      );
      setExpand(true);
    } else {
      setChildFooterLeft(null);
      setChildFooter(null);
      setExpand(false);
    }
  }, [clienteName, digitalizacionesAfacturar]);


  useEffect(() => {
    if (digitalizacionesAfacturar.digitalizaciones_contenidos.length > 0) {
      setCuentaDigitalizaciones(clienteIdSearch.id_cuentas);
    } else {
      setCuentaDigitalizaciones(false);
    }
  }, [digitalizacionesAfacturar]);


  //NOTE FUNCION PARA CONSUMIR SERVICIO COMPROBANTES
  const onClickSubmit = async () => {
    let response = await setComprobantesDigitalizacionesData(digitalizacionesAfacturar)
    if (response.status === 'true') {
      setRespuestaComprobante(response);
      setAbrirRespuestaComprobante(true);
    } else {
      setMessage(response.message);
      setSeverity('warning');
      setSnackbarVisible(true);
    }
    setDigitalizacionesAfacturar({ digitalizaciones_contenidos: [], contenidos: [] })
    setDigitalizacionesSeleccionadas({ digitalizaciones_contenidos: [], contenidos: [] })
    setDigitalizacionesSeleccionadasCompleto({ digitalizaciones_contenidos: [], contenidos: [] })
  };

  //NOTE FUNCION PARA COPIAR URL
  const onClickCopy = async () => {
    navigator.clipboard.writeText(respuestaComprobante.wsResponse.link);
    setMessage("Se a copiado la URL correctamente");
    setSeverity('success');
    setSnackbarVisible(true);
  };

  const handleHistoricoButton = () => {
    toggleModalHistorico(params.id);
    handleCloseMenu()
  };

  const handleEditarButton = () => {
    const clienteSectorConcat = params.row.cliente + " - " + params.row.sector;
    setClienteSectorFormCajas(true);
    setNameFormCajas("Modificacion de Caja")
    setDescripcionCuentaSectorFormCajas(clienteSectorConcat)
    setDataCajasFormEdit(params.row);
    toggleModalCajasForm(params.row.id_cuentas_localizaciones, params.row);
    handleCloseMenu()
  };

  //Funcion que abre y cierra el modal del formulario de contenidos
  const toggleModalExcedida = async () => {
    if (!modalStateExcedida) {
      setActualizarListado(false);
    }
    setModalStateExcedida(!modalStateExcedida);

  };

  const toggleModalDeformada = async () => {
    if (!modalStateDeformada) {
      setActualizarListado(false);
    }
    setModalStateDeformada(!modalStateDeformada);

  };


  const handleExcedidaButton = () => {
    setIdCaja(params.id);
    const mensaje = params.row.excedida === "1"
      ? `Se marcará la caja con ID ${params.id} como NO excedida, ¿Desea continuar?`
      : `Se marcará la caja con ID ${params.id} como excedida, ¿Desea continuar?`;
    setMensajeExcedida(mensaje);
    setCajaExcedida(params.row.excedida === "1" ? true : false);
    toggleModalExcedida();
    handleCloseMenu()
  };

  const handleDeformadaButton = () => {
    setIdCaja(params.id);
    const mensaje = params.row.deformada === "1"
      ? `Se marcará la caja con ID ${params.id} como NO deformada, ¿Desea continuar?`
      : `Se marcará la caja con ID ${params.id} como deformada, ¿Desea continuar?`;
    setMensajeDeformada(mensaje);
    setCajaDeformada(params.row.deformada === "1" ? true : false);
    toggleModalDeformada();
    handleCloseMenu()
  };


    const handleConfirmExcedida = async () => {
      const data = [{ id: idCaja, excedida: cajaExcedida ? "0" : "1" }];
      const responseServicio = await postCajas(data);
  
      if (responseServicio.status === "false") {
        setMessage("No se pudo realizar la modificacion del campo excedida!");
        setSeverity("error");
        setSnackbarVisible(true);
      } else {
        const mensajeSuccess = cajaExcedida ? "La caja cambio a no excedida" : "La caja cambio a excedida";
        setMessage(mensajeSuccess);
        setSeverity("success");
        setSnackbarVisible(true);
        setActualizarListado(true);
        toggleModalExcedida();
      }
    };
  
    const handleConfirmDeformada = async () => {
      const data = [{ id: idCaja, deformada: cajaDeformada ? "0" : "1" }];
      const responseServicio = await postCajas(data);
  
      if (responseServicio.status === "false") {
        setMessage("No se pudo realizar la modificacion del campo deformada!");
        setSeverity("error");
        setSnackbarVisible(true);
      } else {
        const mensajeSuccess = cajaExcedida ? "La caja cambio a no deformada" : "La caja cambio a deformada";
        setMessage(mensajeSuccess);
        setSeverity("success");
        setSnackbarVisible(true);
        setActualizarListado(true);
        toggleModalDeformada();
      }
    };

  return (
    <Grid style={{ background: "white", paddingBottom: "0%" }}>
      {/* NOTE BOTON BUSCAR CONTENIDO QUE ABRE EL FORMULARIO */}
      {abrirBusqueda && (
        //Aca va el componente de busqueda
        <SimpleDialogComponent
          open={abrirBusqueda}
          modalName={"Busqueda de contenidos"}
          child={
            <SearchFormGeneral
              toggleModal={toggleModal}
              proceso={proceso}
              dialogPreguntaDistintoCliente={true}
              onClickSubmitDistintoCliente={limpiarFooter}
              cuentaDigitalizaciones={cuentaDigitalizaciones}
              digitalizado={true} />
          }
          setPushData={setPushData}
          handleClose={toggleModal}
          buttonEnviar={false}
          buttonCancelar={true}
          maxWidth="xl"
        ></SimpleDialogComponent>
      )}
      {/* NOTE LIST TABLE DE CONTENIDOS */}
      <Grid>
        {conJerarquia && (<ListTablePaginated options={options} />)}
        {!conJerarquia && (<ListTablePaginated options={options2} />)}

      </Grid>

      {/* NOTE AGREGAR CONTENIDOS DIGITALIZACIONES */}
      {/* <AgregarContenido
        tipoContenidoSelect={tipoContenidoSelect}
        contenidoSeleccionado={contenidoSeleccionado}
      /> */}

      {modalStateCajasForm && (
        <SimpleDialogComponent
          open={modalStateCajasForm}
          modalName={nameFormCajas}
          child={<FormCajasProcesosVarios sectorIdFormCajas={sectorIdFormCajas} clienteSectorFormCajas={clienteSectorFormCajas}
            descripcionCuentaSectorFormCajas={descripcionCuentaSectorFormCajas} toggleModal={toggleModalCajasForm} dataCajasFormEdit={dataCajasFormEdit} />}
          setPushData={toggleModalCajasForm}
          handleClose={toggleModalCajasForm}
          buttonEnviar={false}
          buttonCancelar={true}
        />
      )}

      {modalStateHistorico && (
        <SimpleDialogComponent
          open={modalStateHistorico}
          modalName={"Historico"}
          child={<MovimientosTimelineMUI data={historicoCaja} />}
          setPushData={toggleModalMovimientos}
          handleClose={toggleModalMovimientos}
          buttonEnviar={false}
          buttonCancelar={true}
        />
      )}

      {/* NOTE DIALOGO PARA EDITAR LAS IMAGENES */}
      {openDialogImage && (
        <DigitalizacionesContenido
          openDialogImage={openDialogImage}
          contenidoSeleccionado={contenidoSeleccionado}
          setOpenDialogImage={setOpenDialogImage}
          setAlertImagesSave={setAlertImagesSave}
          setActualizarListado={setActualizarListado}
          setEliminar={setEliminar}
          tipoContenidoList1={tipoContenidoList}
          // setTipoContenidoList={setTipoContenidoList}
          metadatosContenidoSeleccionado={metadatosContenidoSeleccionado}
        />
      )}
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />
      {abrirRespuestaComprobante && (
        //Aca va el componente de busqueda
        <SimpleDialogComponent
          open={abrirRespuestaComprobante}
          modalName={"Resultado de la Solicitud"}
          child={
            <Grid sx={{
              mt: 1, minWidth: "100%", textAlign: "center",
              wordBreak: "break-all"
            }}>
              <InfoIcon sx={{ fontSize: "400%", color: "#2669F0" }} />
              <Typography align="center" variant="h4" gutterBottom component="div">
                {respuestaComprobante.message}
              </Typography>
              <Grid wrap="nowrap">Link:
                <Link target="_blank" href={respuestaComprobante.wsResponse.link} variant="body2">
                  {respuestaComprobante.wsResponse.link}
                </Link>
              </Grid>
              <Grid sx={{ paddingTop: "30px" }}>
                <Buttons
                  onClickSubmit={
                    onClickCopy
                  }
                  labelButtonSave={"Copiar URL"}
                  buttonCerrar={toggleModalRespuestaComprobante}
                />
              </Grid>
            </Grid>
          }
          setPushData={setPushData}
          handleClose={toggleModalRespuestaComprobante}
          buttonEnviar={false}
          buttonCancelar={true}
        ></SimpleDialogComponent>
      )}
      {modalStateHistorico && (
        <SimpleDialogComponent
          open={modalStateHistorico}
          modalName={"Historico"}
          child={<MovimientosTimelineMUI data={historicoCaja} />}
          setPushData={toggleModalMovimientos}
          handleClose={toggleModalMovimientos}
          buttonEnviar={false}
          buttonCancelar={true}
        />
      )}
       {modalStateExcedida && (
              <ConfimDialogComponent
                open={modalStateExcedida}
                modalName={"Marcar como excedida"}
                mensaje={mensajeExcedida}
                handleConfirm={handleConfirmExcedida}
                handleClose={toggleModalExcedida}
              />
            )}
      
            {modalStateDeformada && (
              <ConfimDialogComponent
                open={modalStateDeformada}
                modalName={"Marcar como deformada"}
                mensaje={mensajeDeformada}
                handleConfirm={handleConfirmDeformada}
                handleClose={toggleModalDeformada}
              />
            )}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={onClickEtiqueta}>
          <StyleIcon color="info" sx={{ mr: 2 }} />
          Imprimir
        </MenuItem>
        {Historico && (
          <MenuItem
            onClick={handleHistoricoButton}
            {...(params?.id?.includes("cliente") || params?.id?.includes("sector")
              ? { hidden: true }
              : {})}>
            <HistoryIcon color="info" sx={{ mr: 2 }} />
            Historico
          </MenuItem>
        )}
        {Editar && (
          <MenuItem
            onClick={handleEditarButton}
            {...(params?.id?.includes("cliente") || params?.id?.includes("sector")
              ? { hidden: true }
              : {})}>
            <EditIcon color="info" sx={{ mr: 2 }} />
            Editar
          </MenuItem>
        )}
        {MarcarExcedida && (
          <MenuItem
            onClick={handleExcedidaButton}
            {...(params?.id?.includes("cliente") || params?.id?.includes("sector")
              ? { hidden: true }
              : {})}>
            <WarningAmberIcon color="info" sx={{ mr: 2 }} />
            {params?.row?.excedida === "1" ? "Marcar como no excedida" : "Marcar como excedida"}
          </MenuItem>
        )}
        {MarcarDeformada && (
          <MenuItem
            onClick={handleDeformadaButton}
            {...(params?.id?.includes("cliente") || params?.id?.includes("sector")
              ? { hidden: true }
              : {})}>
            <BrokenImageIcon color="info" sx={{ mr: 2 }} />
            {params?.row?.deformada === "1" ? "Marcar como no deformada" : "Marcar como deformada"}
          </MenuItem>
        )}

      </Popover>
    </Grid>
  );
};
